// Procore connection + browsing (back/routes/procore.js) and per-project delivery
// settings (back/routes/integrations.js). The api helpers resolve an error body rather
// than throwing on it, so every call here turns { error } into a throw.
import { get, post, globalPut, remove } from "api";

// post / globalPut throw the parsed error body (a plain object), get resolves it
const ok = (p) =>
  p.then(
    (r) => {
      if (r && r.error) throw new Error(r.error);
      return r;
    },
    (e) => {
      throw e instanceof Error ? e : new Error((e && (e.error || e.message)) || "The server refused the request");
    }
  );

export const getProcoreStatus = () => ok(get(`/procore/status`));
// `connection`: one of the company's Procore accounts by id ('new' = add one when connecting)
const withConn = (connection) => (connection ? `?connection=${encodeURIComponent(connection)}` : "");
export const getProcoreConnectUrl = (connection) => ok(get(`/procore/connect${withConn(connection)}`));
export const disconnectProcore = (connection) => ok(post(`/procore/disconnect`, connection ? { connection } : {}));
export const getProcoreCompanies = (connection) => ok(get(`/procore/companies${withConn(connection)}`));
export const getProcoreProjects = (companyId, connection) => ok(get(`/procore/companies/${encodeURIComponent(companyId)}/projects${withConn(connection)}`));
export const getProcoreFolder = (companyId, projectId, folderId, connection) =>
  ok(get(`/procore/companies/${encodeURIComponent(companyId)}/projects/${encodeURIComponent(projectId)}/folders/${encodeURIComponent(folderId || "root")}${withConn(connection)}`));

export const getIntegrationCards = (projectIds) => ok(get(`/integrations?projects=${projectIds.join(",")}`));
export const getProjectIntegrations = (projectId) => ok(get(`/integrations/${projectId}`));
// `destination`: one of the project's destinations by id, 'new' to add one; none = the provider's first
const dest = (destination) => (destination ? `?destination=${encodeURIComponent(destination)}` : "");
export const saveProjectIntegration = (projectId, provider, body, destination) => ok(globalPut(`/integrations/${projectId}/${provider}${dest(destination)}`, body));
export const removeProjectIntegration = (projectId, provider, destination) => ok(remove(`/integrations/${projectId}/${provider}${dest(destination)}`, {}));
export const getDeliveries = (projectId, kind) => ok(get(`/integrations/${projectId}/deliveries?kind=${kind || ""}&limit=200`));
export const retryDelivery = (projectId, id) => ok(post(`/integrations/${projectId}/deliveries/${id}/retry`, {}));

// connect without the Procore sign-in: a token or Cookie header from the user's browser
export const connectProcoreToken = (token, connection) => ok(post(`/procore/token`, connection ? { token, connection } : { token }));
